export default "__VITE_ASSET__NKLB0cUl__"